import { GET_QUESTIONS } from '../../actions/questions';

const questionsReducer = (state = {}, action = {}) => {
  const { type = '', questionsData = {} } = action;

  switch (type) {
    case GET_QUESTIONS.INITIATE:
      return {
        ...state,
      };
    case GET_QUESTIONS.SUCCESS:
      return {
        ...state,
        questionsData,
      };
    case GET_QUESTIONS.FAILED:
      return {
        ...state,
      };
    default:
      return state;
  }
};

export default questionsReducer;
